module.exports = __webpack_public_path__ + "static/media/iconCommunicationActive.d9b505e5.svg";